export enum DeclineReasonsActionType {
  GetDeclineReasons = 'declineReasons/getDeclineReasons',
  GetDeclineReasonsSuccess = 'declineReasons/getDeclineReasonsSuccess',
  GetDeclineReasonsFailure = 'declineReasons/getDeclineReasonsFailure',
  UpdateDeclineReasons = 'declineReasons/updateDeclineReasons',
  UpdateDeclineReasonsSuccess = 'declineReasons/updateDeclineReasonsSuccess',
  UpdateDeclineReasonsFailure = 'declineReasons/updateDeclineReasonsFailure',
}
